/**
 * LiveSyncIndicator — small pill button with pulsing dot + last-sync time.
 * Clicking toggles the polling on/off (usually wired to useLiveSyncPolling).
 */
import { Loader2 } from 'lucide-react';

export function LiveSyncIndicator({
  active,
  lastSyncAt,
  loading,
  language,
  onToggle,
  onRefresh,
}) {
  return (
    <div className="flex items-center justify-end gap-2 mb-3">
      <button
        onClick={onToggle}
        className={`inline-flex items-center gap-2 text-[11px] px-3 py-1.5 rounded-lg border transition-all ${
          active
            ? 'bg-emerald-500/10 border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/15'
            : 'bg-white/5 border-white/10 text-white/50 hover:text-white/80'
        }`}
        title={language === 'ar' ? 'يعمل المزامنة الحية كل 8 ثواني' : 'Live sync every 8 seconds'}
        data-testid="live-sync-toggle"
      >
        <span
          className={`w-1.5 h-1.5 rounded-full ${
            active ? 'bg-emerald-400 animate-pulse' : 'bg-white/30'
          }`}
        />
        {active
          ? language === 'ar' ? 'مزامنة حية' : 'Live sync'
          : language === 'ar' ? 'المزامنة موقوفة' : 'Sync paused'}
        {lastSyncAt && (
          <span className="text-white/40 font-mono ms-1">
            {lastSyncAt.toLocaleTimeString(language === 'ar' ? 'ar-AE' : 'en-AE', {
              hour: '2-digit', minute: '2-digit', second: '2-digit',
            })}
          </span>
        )}
      </button>
      <button
        onClick={onRefresh}
        className="p-1.5 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-white/70"
        title={language === 'ar' ? 'تحديث الآن' : 'Refresh now'}
        data-testid="manual-refresh"
      >
        <Loader2 className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
      </button>
    </div>
  );
}
